import { render } from "./MessageUI.vue?vue&type=template&id=498da40a&scoped=true"
import script from "./MessageUI.vue?vue&type=script&lang=js"
export * from "./MessageUI.vue?vue&type=script&lang=js"

import "./MessageUI.vue?vue&type=style&index=0&id=498da40a&scoped=true&lang=css"

import exportComponent from "/builds/coditas-projects/dialog360-whatsapp/frontend/whatsapp-exotel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498da40a"]])

export default __exports__